import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

import getConfig from 'Util/Config';

const {
  firebase: { config, enable },
} = getConfig() || {};

if (enable && !firebase.apps.length) {
  firebase.initializeApp(config);
}

export default firebase;
